import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowDown } from "lucide-react";
import Nav from "../Nav";
import { UAE } from "../../mock";

export const HomeHero = () => (
  <section className="mp-dark relative overflow-hidden" data-testid="home-hero">
    <div className="absolute inset-0">
      <img src="/mp/ghq-lounge.jpg" alt="Global Headquarters — Abu Dhabi" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-[#151310]/72" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#151310] via-[#151310]/35 to-[#151310]/55" />
    </div>
    <div className="relative z-10">
      <Nav theme="dark" />
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="min-h-[76vh] flex flex-col justify-center py-20 md:py-28">
          <h1 className="font-display font-light text-[11vw] md:text-[76px] leading-[0.92] tracking-tight mt-6 mp-fade" style={{ animationDelay: "0.1s" }}>
            Medium Plenty
            <span className="block text-[#c9a15f]">&times; UAE</span>
          </h1>
          <div className="mt-10 md:mt-14 grid md:grid-cols-12 gap-8 items-end">
            <p className="md:col-span-7 lg:col-span-6 text-[#c8c2b4] text-[15px] md:text-[16px] leading-relaxed font-light mp-fade" style={{ animationDelay: "0.2s" }}>
              {UAE.heroIntro}
            </p>
            <div className="md:col-span-5 lg:col-span-6 md:flex md:justify-end mp-fade" style={{ animationDelay: "0.3s" }}>
              <Link
                to="/inquiries"
                data-testid="hero-inquiry-link"
                className="inline-flex items-center gap-2 border border-[rgba(236,231,219,0.35)] px-7 py-4 font-label text-[11px] text-[#ece7db] hover:bg-[#ece7db] hover:text-[#1c1a16] transition-colors duration-300"
              >
                Start an Inquiry <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.5} />
              </Link>
            </div>
          </div>
        </div>
        <div className="pb-10 flex items-center gap-3 text-[#928c7d]">
          <ArrowDown className="w-4 h-4 animate-bounce" strokeWidth={1.5} />
          <span className="font-label text-[10px]">Scroll</span>
        </div>
      </div>
    </div>
  </section>
);
